import { DoodProductModel } from '@core/models/product.model';
import { DeclinableProductStep } from '../stepper.type';
import { StepInfo } from '@core/models/stepper.model';
import { CategoryProductValidity } from '@shared/local-store/cart/util/cart-declinable-product-util';

export class DeclinableStepperUtil {
  static calculateDeclinableStepStates({
    declinableProduct,
    totalSelectedQuantity,
    isValid,
    selectedCategoryId,
    selectableCategoryIds,
    setSelectedStep,
    compiledCategoriesValidity,
    _debugMissingStepDetected,
  }: {
    declinableProduct: DoodProductModel;
    totalSelectedQuantity: number;
    selectedCategoryId: string | undefined;
    isValid: boolean;
    selectableCategoryIds: (string | undefined)[] | undefined;
    setSelectedStep: (stepsId: StepInfo) => void;
    compiledCategoriesValidity: CategoryProductValidity[];
    /**
     *  only used to check if a user has a missing step (the selection may be loosed...)
     */
    _debugMissingStepDetected: (data: {
      declinableProduct: DoodProductModel;
      isValid: boolean;
      selectableCategoryIds: (string | undefined)[] | undefined;
      currentStepIndex: number | undefined;
      missingRequiredCategories: CategoryProductValidity[];
    }) => void;
  }): DeclinableProductStep {
    const hasMaxQuantity = declinableProduct.max_count !== undefined;

    const isMaxCountReached = totalSelectedQuantity >= (declinableProduct.max_count ?? Infinity);

    const currentStepIndex = selectableCategoryIds?.findIndex(
      // todo check mais je pense qu'on peut supprimer
      selectableCategoryId => selectedCategoryId === selectableCategoryId, // todo verify the id is correct
    );

    // #DOOD-1026 Sometimes some categories selections seems missing https://dood-team.atlassian.net/browse/DOOD-1026?focusedCommentId=12237
    // This will enable to show the category with missing selection and allow the user to add the product in the cart
    const missingRequiredCategories = compiledCategoriesValidity.filter(
      ({ isCategoryValid }) => !isCategoryValid,
    );
    console.log('missingRequiredCategories', missingRequiredCategories);
    const hasNextMissingCategory = !!missingRequiredCategories?.length;
    const nextMissingCategoryId = compiledCategoriesValidity[0]?.categoryId;
    const firstMissingCategoryIndex = compiledCategoriesValidity.findIndex(
      ({ isCategoryValid }) => !isCategoryValid,
    );

    const canMakeMoreChoices = !!(hasMaxQuantity ? !isMaxCountReached : false);
    const hasNextCategoryIndex =
      typeof currentStepIndex == 'number' &&
      currentStepIndex < (selectableCategoryIds?.length ?? 0) - 1;
    const hasNextCategory = hasNextCategoryIndex || hasNextMissingCategory;
    const hasPreviousCategory = typeof currentStepIndex == 'number' && currentStepIndex > 0;
    const nextStepId =
      typeof currentStepIndex == 'number'
        ? selectableCategoryIds?.[currentStepIndex + 1]
        : (nextMissingCategoryId ?? undefined);
    const previousStepId =
      typeof currentStepIndex == 'number'
        ? selectableCategoryIds?.[currentStepIndex - 1]
        : undefined;

    if (
      hasNextMissingCategory &&
      typeof currentStepIndex == 'number' &&
      firstMissingCategoryIndex < currentStepIndex
    ) {
      // should not append, but if it does, we have to investigate
      _debugMissingStepDetected({
        declinableProduct,
        isValid,
        selectableCategoryIds,
        currentStepIndex,
        missingRequiredCategories,
      });
    }
    return {
      type: 'declinable',
      product: declinableProduct,
      selectedCategoryId,
      selectedStepId: selectedCategoryId,
      isValid,
      canMakeMoreChoices,
      minStepCount: declinableProduct.min_count ?? 0,
      maxStepCount: declinableProduct.max_count ?? Infinity,
      count: totalSelectedQuantity,
      hasNextStep: hasNextCategory,
      hasPreviousStep: hasPreviousCategory,
      previousStepId,
      nextStepId,
      skippable: false, // for now, there is no cases where the declinable product is preselected
      nextStep: hasNextCategory
        ? {
            categoryId: nextStepId,
          }
        : undefined,
      previousStep: hasPreviousCategory
        ? {
            categoryId: previousStepId,
          }
        : undefined,
      setSelectedStep,
    } satisfies DeclinableProductStep;
  }
}
